module.exports = __webpack_public_path__ + "img/222.cc45e284.jpg";